import React, { useEffect, useState } from "react";
import "../../css/header.scss";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header
      className={`header ${
        scrolled ? "header--scrolled" : "header--transparent"
      }`}
    >
      <div className="header__inner">
        <button
          className="header__logo"
          onClick={() => {
            navigate("/");
            toTop();
          }}
          aria-label="Home"
        >
          <img alt="" src="/head/ico-new.png" />
        </button>
      </div>
    </header>
  );
};

export default Header;
